import axios from "axios";
import config from "src/config";
import { IContactsResults } from "src/pages/contact/interfaces";
import {
  getJsonContentHeader,
  getAuthHeader,
  getAxiosOptions,
} from "../../headers";

const getContact = async (
  accessToken: string,
  id: string,
  organisationId: string
): Promise<IContactsResults> => {
  const options = {
    headers: { ...getAuthHeader(accessToken), ...getJsonContentHeader() },
    ...getAxiosOptions(),
  };

  const response = await axios.get(
    `${config.projectManagementService.url}/talent-hub/talent-contact/${id}?orgId=${organisationId}`,
    options
  );

  return response.data as IContactsResults;
};

export default getContact;
